// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"dada785e","585":"5c6b5fbc"}[chunkId] + ".chunk.js";
};